import React, { memo } from 'react';
import '../css/bg.css';
import Error from '../Components/Assets/404.svg';
import Background from '../Components/background/background';

// Memoized component to prevent unnecessary re-renders
const NotFound = memo(() => {
    return (
        <div className="relative h-screen w-screen bg-white overflow-hidden">
            {/* Animated Background */}
            <Background />
            
            {/* Centered Error Content */}
            <div className="absolute inset-0 flex items-center justify-center p-4">
                <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg text-center max-w-sm sm:max-w-lg w-full">
                    <img
                        src={Error}
                        alt="Page not found illustration"
                        className="mx-auto mb-4 sm:mb-6 w-32 h-24 sm:w-40 sm:h-32 object-contain"
                        loading="lazy"
                        width="160"
                        height="128"
                    />
                    <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                        Page Not Found
                    </h1>
                    <p className="text-gray-600 mb-6 text-sm sm:text-base">
                        Sorry, the page you're looking for doesn't exist.
                    </p>
                </div>
            </div>
        </div>
    );
});

// Set display name for better debugging
NotFound.displayName = 'NotFound';

export default NotFound;